import { basenameFind, getTargetProperty } from "../common.js";
const image = {
    jpath: ['image'],
    find: basenameFind,
    getProperty: getTargetProperty,
};
export default image;
//# sourceMappingURL=image.js.map